export const routeBaseTitle = 'Lerner Sports';
export const routeTitleSeparator = '|';